(function() {
  function initDiamondQualitySelector() {
    const containers = document.querySelectorAll('.diamond-quality-selector-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
      const buttons = container.querySelectorAll('.diamond-quality-button');
      const activeLabel = container.querySelector('.diamond-quality-active');

      if (!buttons.length || !activeLabel) return;

      // Click handlers for quality buttons
      buttons.forEach(button => {
        button.addEventListener('click', function() {
          const label = this.dataset.label;
          
          // Remove active class from all buttons
          buttons.forEach(b => b.classList.remove('active'));
          
          // Add active class to clicked button
          this.classList.add('active');
          
          // Update label text
          if (activeLabel && label) {
            activeLabel.textContent = label;
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiamondQualitySelector);
  } else {
    initDiamondQualitySelector();
  }

  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', initDiamondQualitySelector);
})();

